import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SupabaseClient, createClient } from '@supabase/supabase-js';

@Injectable({
  providedIn: 'root'
})
export class SupabaseService {
  public supabase: SupabaseClient;
  queue: SupabaseClient<any, "pgmq_public", any>;

  // public queue: SupabaseClient;

  constructor() {
    this.supabase = createClient(
      environment.SUPABASE_URL,
      environment.SUPABASE_KEY,
      {
        auth: {
          persistSession: true, // Use persistent session for authenticated requests
        },
        db: { schema: "public" },
      }
    );

    this.queue = createClient(
      environment.SUPABASE_URL,
      environment.SUPABASE_KEY,
      {
        auth: {
          persistSession: true, // Use persistent session for authenticated requests
        },
        db: { schema: "pgmq_public" },
      }
    );
  }
}
